export enum EnumTipoDocumentoAssDigital {
    PASTA_PRESTACAO_CONTAS = "PASTA_PRESTACAO_CONTAS",
}

export const getDocumentoFormatado = (tipoDocumento: EnumTipoDocumentoAssDigital) => {
    switch (tipoDocumento) {
        case EnumTipoDocumentoAssDigital.PASTA_PRESTACAO_CONTAS:
            return 'Pasta de prestação de contas';
        default:
            return tipoDocumento; 
    }
}
